(function () {
  'use strict';
  if (window.__timbaAnalyticsChoice) return;
  window.__timbaAnalyticsChoice = true;
  function start() {
    if (!window.Shopify || !window.Shopify.loadFeatures) return;
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      var privacy = window.Shopify.customerPrivacy;
      if (error || !privacy || !privacy.setTrackingConsent) return;
      function enhance() {
        var banner = document.getElementById('shopify-pc__banner');
        if (!banner || banner.querySelector('#timba-accept-analytics')) return;
        var accept = banner.querySelector('#shopify-pc__banner__btn-accept');
        var paragraph = banner.querySelector('.shopify-pc__banner__body p');
        var policy = banner.querySelector('#shopify-pc__banner__body-policy-link');
        if (!accept || !paragraph || !policy) return;
        var button = document.createElement('button');
        button.id = 'timba-accept-analytics';
        button.type = 'button';
        button.className = accept.className;
        button.textContent = 'Accept analytics only';
        var status = document.createElement('p');
        status.setAttribute('role', 'status');
        status.hidden = true;
        function fail() {
          button.disabled = false;
          status.textContent = 'Your choice could not be saved. Please try again or select Choose cookies.';
          status.hidden = false;
        }
        button.addEventListener('click', function () {
          button.disabled = true;
          status.hidden = true;
          try {
            privacy.setTrackingConsent({ analytics: true, marketing: false, preferences: false, sale_of_data: false }, function (result) {
              if (result && result.error) { fail(); return; }
              var saved = privacy.currentVisitorConsent();
              if (saved.analytics !== 'yes' || saved.marketing !== 'no' || saved.preferences !== 'no') { fail(); return; }
              banner.style.display = 'none';
              button.disabled = false;
            });
          } catch (_) { fail(); }
        });
        var decline = banner.querySelector('#shopify-pc__banner__btn-decline');
        if (decline) decline.textContent = 'Essential cookies only';
        paragraph.replaceChildren(document.createTextNode('We use essential cookies to run the shop. With your permission, analytics records how you browse and interact so we can improve your shopping experience. See Choose cookies for details and our '), policy, document.createTextNode('.'));
        paragraph.after(status);
        accept.before(button);
        accept.style.display = 'none';
        accept.setAttribute('aria-hidden', 'true');
      }
      enhance();
      new MutationObserver(enhance).observe(document.body, { childList: true, subtree: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();